import * as Redux from 'redux';

export enum LoginActionType {
	LOGIN = 'login/execute',
	RESULT = 'login/result',
	CHANGE_USERID = 'login/change/userid',
	CHANGE_PASSWD = 'login/change/passwd',
}
export interface LoginAction extends Redux.Action {
	type: LoginActionType.LOGIN
}
export const getActionLogin = (): LoginAction => ({
	type: LoginActionType.LOGIN
});

export interface LoginOnChangeUserIdAction extends Redux.Action {
	type: LoginActionType.CHANGE_USERID
	payload:{
		userId:string
	}
}
export const actionLoginOnChangeUserId = (val:string): LoginOnChangeUserIdAction => ({
	type: LoginActionType.CHANGE_USERID,
	payload:{
		userId:val
	}
});

export interface LoginOnChangePasswordAction extends Redux.Action {
	type: LoginActionType.CHANGE_PASSWD
	payload:{
		password:string
	}
}
export const actionLoginOnChangePassword = (val:string): LoginOnChangePasswordAction => ({
	type: LoginActionType.CHANGE_PASSWD,
	payload:{
		password:val
	}
});

export interface LoginResult extends Redux.Action {
	type: LoginActionType.RESULT,
	payload:{
		errorMsg:string
	}
}
export const getResultLogin = (err:string): LoginResult => ({
	type: LoginActionType.RESULT,
	payload:{
		errorMsg:err
	}
});

export type LoginActions = LoginAction | LoginResult | LoginOnChangeUserIdAction | LoginOnChangePasswordAction// | DecrementAction

